import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from "@angular/core";
import { GetPartnerInvitationAgreementPartnership } from "@platform-app/app/core/api/models";
import { AffiliationAgreementNameTileComponent } from "@platform-app/app/shared/affiliation-agreements/components/affiliation-agreement-name-tile/affiliation-agreement-name-tile.component";
import { WrappedChipsRowsComponent } from "@platform-app/app/shared/common/components/wrapped-chips-rows/wrapped-chips-rows.component";
import { US_DatePipe } from "@platform-app/app/shared/common/pipes";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-pending-partnership-message",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AffiliationAgreementNameTileComponent,
    US_DatePipe,
    ButtonModule,
    WrappedChipsRowsComponent,
  ],
  templateUrl: "./pending-partnership-message.component.html",
})
export class PendingPartnershipMessageComponent {
  partnership = input.required<GetPartnerInvitationAgreementPartnership>();
  viewAgreement = output<void>();

  agreement = computed(() => this.partnership().agreement);

  disciplines = computed(() =>
    this.agreement().disciplines.length
      ? this.agreement().disciplines
      : ["Any discipline"],
  );
}
